import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Color: { input: any; output: any; }
  ISO8601DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Score: { input: any; output: any; }
};

export type AccessToken = {
  __typename?: 'AccessToken';
  createdAt: Scalars['ISO8601DateTime']['output'];
  expiresIn: Scalars['Int']['output'];
  scopes: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type AdditionalPosterDataInput = {
  optionId: Scalars['ID']['input'];
  optionSetId: Scalars['ID']['input'];
};

export type AdditionalShare = Node & {
  __typename?: 'AdditionalShare';
  additionalPoints: Scalars['Int']['output'];
  buttonText: Scalars['String']['output'];
  icon?: Maybe<Image>;
  iconType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  instructions: Scalars['String']['output'];
  link: Scalars['Boolean']['output'];
  linkButtonText?: Maybe<Scalars['String']['output']>;
  linkHref?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  userInput: Scalars['Boolean']['output'];
  userInputButtonText?: Maybe<Scalars['String']['output']>;
  userInputPlaceholder?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AdditionalShare */
export type AdditionalShareInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  shareId: Scalars['ID']['input'];
  userInput?: InputMaybe<Scalars['String']['input']>;
  via: Scalars['ID']['input'];
};

/** Autogenerated return type of AdditionalShare. */
export type AdditionalSharePayload = {
  __typename?: 'AdditionalSharePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type BackdropSettings = {
  __typename?: 'BackdropSettings';
  answerColour: Scalars['String']['output'];
  firstNameColour: Scalars['String']['output'];
  highlightColour: Scalars['String']['output'];
  lastNameColour: Scalars['String']['output'];
  variableColour: Scalars['String']['output'];
};

export type BasicQuiz = Node & Quiz & {
  __typename?: 'BasicQuiz';
  additionalSharing: Array<AdditionalShare>;
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  enterBeforeQuiz: Scalars['Boolean']['output'];
  form: QuizForm;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  questions: QuestionConnection;
  stylesheet: QuizStylesheet;
  template: QuizTemplate;
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
  useImageOptions: Scalars['Boolean']['output'];
};


export type BasicQuizQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type BasicQuizEntry = Entry & HasEntryTrivia & Node & {
  __typename?: 'BasicQuizEntry';
  answers: Array<OptionSetAnswer>;
  correctAnswerQuestionTrivia: Scalars['String']['output'];
  correctAnswerResultsTrivia: Scalars['String']['output'];
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  data: Array<OptionSetEntry>;
  id: Scalars['ID']['output'];
  question: BasicQuizQuestion;
  quiz: BasicQuiz;
  score: Scalars['Int']['output'];
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type BasicQuizQuestion = Node & Question & {
  __typename?: 'BasicQuizQuestion';
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  data: Array<OptionSetQuestion>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
  version: Scalars['Int']['output'];
};

export type Category = {
  __typename?: 'Category';
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** The connection type for Category. */
export type CategoryConnection = {
  __typename?: 'CategoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CategoryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Category>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CategoryEdge = {
  __typename?: 'CategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Category>;
};

export type CategoryEntry = {
  __typename?: 'CategoryEntry';
  questionId: Scalars['ID']['output'];
  value: Scalars['Int']['output'];
};

export type CategoryEntryInput = {
  questionId: Scalars['ID']['input'];
  value: Scalars['Int']['input'];
};

export type CategoryQuestion = {
  __typename?: 'CategoryQuestion';
  id: Scalars['ID']['output'];
  image: Image;
  title?: Maybe<Scalars['String']['output']>;
};

export type CategoryValue = {
  __typename?: 'CategoryValue';
  categoryId: Scalars['ID']['output'];
  value: Scalars['Int']['output'];
};

export type Client = Node & {
  __typename?: 'Client';
  id: Scalars['ID']['output'];
};

/** Web color formats */
export enum ColorFormats {
  /** HSL Function Values, e.g. H S L */
  HslFunction = 'HSL_FUNCTION',
  /** LAB Function Values, e.g. L a b */
  LabFunction = 'LAB_FUNCTION',
  /** LCH Function Values, e.g. L C H */
  LchFunction = 'LCH_FUNCTION',
  /** RGB Function Values, e.g. R G B */
  RgbFunction = 'RGB_FUNCTION',
  /** RGB Hex Notation, e.g. #RRGGBB[AA] */
  RgbHex = 'RGB_HEX'
}

/** Autogenerated input type of CreateBasicQuizEntry */
export type CreateBasicQuizEntryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: Array<OptionSetEntryInput>;
  questionId: Scalars['ID']['input'];
  quizId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateBasicQuizEntry. */
export type CreateBasicQuizEntryPayload = {
  __typename?: 'CreateBasicQuizEntryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<BasicQuizEntry>;
  errors: Array<MutationError>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateDisappearingImageEntry */
export type CreateDisappearingImageEntryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: Array<OptionSetEntryInput>;
  questionId: Scalars['ID']['input'];
  quizId: Scalars['ID']['input'];
  timeRemaining: Scalars['Float']['input'];
};

/** Autogenerated return type of CreateDisappearingImageEntry. */
export type CreateDisappearingImageEntryPayload = {
  __typename?: 'CreateDisappearingImageEntryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<DisappearingImageEntry>;
  errors: Array<MutationError>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateInteractiveQuizEntry */
export type CreateInteractiveQuizEntryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: Scalars['Float']['input'];
  questionId: Scalars['ID']['input'];
  quizId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateInteractiveQuizEntry. */
export type CreateInteractiveQuizEntryPayload = {
  __typename?: 'CreateInteractiveQuizEntryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<InteractiveQuizEntry>;
  errors: Array<MutationError>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateListGameEntry */
export type CreateListGameEntryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: Array<OptionSetEntryInput>;
  questionId: Scalars['ID']['input'];
  quizId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateListGameEntry. */
export type CreateListGameEntryPayload = {
  __typename?: 'CreateListGameEntryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<ListGameEntry>;
  errors: Array<MutationError>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreatePersonalityQuizEntry */
export type CreatePersonalityQuizEntryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: Array<CategoryEntryInput>;
  questionId: Scalars['ID']['input'];
  quizId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreatePersonalityQuizEntry. */
export type CreatePersonalityQuizEntryPayload = {
  __typename?: 'CreatePersonalityQuizEntryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<PersonalityQuizEntry>;
  errors: Array<MutationError>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreatePosterEntry */
export type CreatePosterEntryInput = {
  backdropId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  posterData?: InputMaybe<PosterDataInput>;
  posterId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreatePosterEntry. */
export type CreatePosterEntryPayload = {
  __typename?: 'CreatePosterEntryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<PosterEntry>;
  errors: Array<MutationError>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreatePosterOrder */
export type CreatePosterOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderEntries: Array<OrderEntryInput>;
  posterId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreatePosterOrder. */
export type CreatePosterOrderPayload = {
  __typename?: 'CreatePosterOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  intent?: Maybe<PaymentIntent>;
  order?: Maybe<PosterOrder>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateScratchAndWinEntries */
export type CreateScratchAndWinEntriesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  quizId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateScratchAndWinEntries. */
export type CreateScratchAndWinEntriesPayload = {
  __typename?: 'CreateScratchAndWinEntriesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entries?: Maybe<Array<ScratchAndWinEntry>>;
  errors: Array<MutationError>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateUser */
export type CreateUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateUser. */
export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  userToken?: Maybe<AccessToken>;
};

/** Payment currencies */
export enum Currency {
  /** New Zealand Dollars */
  Nzd = 'NZD'
}

export type DataEntry = {
  __typename?: 'DataEntry';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DecimalEntry = {
  __typename?: 'DecimalEntry';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DisappearingImageEntry = Entry & HasEntryTrivia & Node & {
  __typename?: 'DisappearingImageEntry';
  answers: Array<OptionSetAnswer>;
  correctAnswerQuestionTrivia: Scalars['String']['output'];
  correctAnswerResultsTrivia: Scalars['String']['output'];
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  data: Array<OptionSetEntry>;
  id: Scalars['ID']['output'];
  question: DisappearingImageQuestion;
  quiz: DisappearingImageQuiz;
  score: Scalars['Int']['output'];
  timeRemaining: Scalars['Float']['output'];
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type DisappearingImageQuestion = Node & Question & {
  __typename?: 'DisappearingImageQuestion';
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  data: Array<OptionSetQuestion>;
  description?: Maybe<Scalars['String']['output']>;
  heroImage?: Maybe<Image>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  points: Scalars['Int']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
  version: Scalars['Int']['output'];
};

export type DisappearingImageQuiz = Node & Quiz & {
  __typename?: 'DisappearingImageQuiz';
  additionalSharing: Array<AdditionalShare>;
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  form: QuizForm;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  questions: QuestionConnection;
  stylesheet: QuizStylesheet;
  template: QuizTemplate;
  timer: Scalars['Int']['output'];
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
};


export type DisappearingImageQuizQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of DualIntegersDualAnswerMutation */
export type DualIntegersDualAnswerMutationInput = {
  answers: Array<IntegerAnswerAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  questionId: Scalars['ID']['input'];
};

/** Autogenerated return type of DualIntegersDualAnswerMutation. */
export type DualIntegersDualAnswerMutationPayload = {
  __typename?: 'DualIntegersDualAnswerMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  question: EventQuestion;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DualOptionSetsSingleAnswerMutation */
export type DualOptionSetsSingleAnswerMutationInput = {
  answer: OptionSetAnswerAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  questionId: Scalars['ID']['input'];
};

/** Autogenerated return type of DualOptionSetsSingleAnswerMutation. */
export type DualOptionSetsSingleAnswerMutationPayload = {
  __typename?: 'DualOptionSetsSingleAnswerMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  question: EventQuestion;
  success: Scalars['Boolean']['output'];
};

export type DurationEntry = {
  __typename?: 'DurationEntry';
  key: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

/** An object with an ID. */
export type Entry = {
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  score: Scalars['Int']['output'];
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** EventEntryAnswer data types */
export type EntryAnswerData = DataEntry | DecimalEntry | DurationEntry | IntegerEntry | OptionSetEntry;

/** The connection type for Entry. */
export type EntryConnection = {
  __typename?: 'EntryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EntryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Entry>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EntryEdge = {
  __typename?: 'EntryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Entry>;
};

export type Event = Node & {
  __typename?: 'Event';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  precision: Scalars['Int']['output'];
  questions: EventQuestionConnection;
};


export type EventQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type EventEntry = Entry & Node & {
  __typename?: 'EventEntry';
  answers: Array<EntryAnswerData>;
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  question: EventQuestion;
  score: Scalars['Int']['output'];
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** EventEvaluators data types */
export type EventEvaluatorsData = IntegerPlusMinus | OptionSetExact | Sorted;

export type EventQuestion = Node & Question & {
  __typename?: 'EventQuestion';
  answers: Array<QuestionAnswerData>;
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  data: Array<EventQuestionData>;
  description?: Maybe<Scalars['String']['output']>;
  evaluators?: Maybe<Array<EventEvaluatorsData>>;
  id: Scalars['ID']['output'];
  judged: Scalars['Boolean']['output'];
  lastJudgedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  type: QuestionTypes;
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
  version: Scalars['Int']['output'];
};

/** The connection type for EventQuestion. */
export type EventQuestionConnection = {
  __typename?: 'EventQuestionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EventQuestionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EventQuestion>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** EventQuestion data types */
export type EventQuestionData = IntegerQuestion | OptionSetQuestion;

/** An edge in a connection. */
export type EventQuestionEdge = {
  __typename?: 'EventQuestionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EventQuestion>;
};

export type HasEntryTrivia = {
  correctAnswerQuestionTrivia: Scalars['String']['output'];
  correctAnswerResultsTrivia: Scalars['String']['output'];
};

export type HeaderImage = {
  __typename?: 'HeaderImage';
  height?: Maybe<Scalars['Int']['output']>;
  mimeType: Scalars['String']['output'];
  role: HeaderImageRole;
  size: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  versions: ImageVersions;
  width?: Maybe<Scalars['Int']['output']>;
};

/** Usage recommendation for Quiz and Poster header images */
export enum HeaderImageRole {
  /** General usage */
  Default = 'DEFAULT',
  /** Poster finalisation pages */
  FinalisePage = 'FINALISE_PAGE',
  /** User form pages */
  FormPage = 'FORM_PAGE',
  /** Instructions pages usage */
  HowToPlayPage = 'HOW_TO_PLAY_PAGE',
  /** Poster personalisation pages */
  PersonalisePage = 'PERSONALISE_PAGE',
  /** Poster positioning pages */
  PositionPage = 'POSITION_PAGE',
  /** User interaction pages */
  QuestionPage = 'QUESTION_PAGE',
  /** Sharing pages */
  SharePage = 'SHARE_PAGE',
  /** Entry page usage */
  SplashPage = 'SPLASH_PAGE'
}

export type HowToPlayPage = {
  __typename?: 'HowToPlayPage';
  icon?: Maybe<Image>;
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  text?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type Image = {
  __typename?: 'Image';
  height?: Maybe<Scalars['Int']['output']>;
  mimeType: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type ImageVersions = {
  __typename?: 'ImageVersions';
  large?: Maybe<Image>;
  /** @deprecated Black and white image versions mostly unused */
  largeBw?: Maybe<Image>;
  medium?: Maybe<Image>;
  /** @deprecated Black and white image versions mostly unused */
  mediumBw?: Maybe<Image>;
  small?: Maybe<Image>;
  /** @deprecated Black and white image versions mostly unused */
  smallBw?: Maybe<Image>;
};

export type ImageWithVersions = {
  __typename?: 'ImageWithVersions';
  height?: Maybe<Scalars['Int']['output']>;
  mimeType: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  versions: ImageVersions;
  width?: Maybe<Scalars['Int']['output']>;
};

export type IntegerAnswer = {
  __typename?: 'IntegerAnswer';
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['Int']['output']>;
};

export type IntegerAnswerAttributes = {
  key: Scalars['String']['input'];
  value: Scalars['Int']['input'];
};

export type IntegerEntry = {
  __typename?: 'IntegerEntry';
  key: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type IntegerPlusMinus = {
  __typename?: 'IntegerPlusMinus';
  difference: Scalars['Int']['output'];
  value: Scalars['Int']['output'];
};

export type IntegerQuestion = {
  __typename?: 'IntegerQuestion';
  key: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

/** The type of interactive game to load for a question */
export enum InteractiveGames {
  /** Test your memory skills */
  MemoryGame = 'MEMORY_GAME',
  /** Infinite runner! */
  RunnerGame = 'RUNNER_GAME'
}

export type InteractiveQuiz = Node & Quiz & {
  __typename?: 'InteractiveQuiz';
  additionalSharing: Array<AdditionalShare>;
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  form: QuizForm;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  questions: QuestionConnection;
  stylesheet: QuizStylesheet;
  template: QuizTemplate;
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
};


export type InteractiveQuizQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type InteractiveQuizEntry = Entry & Node & {
  __typename?: 'InteractiveQuizEntry';
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  data: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  question: InteractiveQuizQuestion;
  quiz: InteractiveQuiz;
  score: Scalars['Int']['output'];
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type InteractiveQuizQuestion = Node & Question & {
  __typename?: 'InteractiveQuizQuestion';
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  game: InteractiveGames;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
  version: Scalars['Int']['output'];
};

export type Leaderboard = Node & Timestamps & {
  __typename?: 'Leaderboard';
  backgroundColor: Scalars['Color']['output'];
  backgroundImage?: Maybe<Image>;
  backgroundTextColor: Scalars['Color']['output'];
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  entriesPageTimer: Scalars['Int']['output'];
  font: LeaderboardFonts;
  foregroundColor: Scalars['Color']['output'];
  foregroundTextColor: Scalars['Color']['output'];
  highlightColor: Scalars['Color']['output'];
  id: Scalars['ID']['output'];
  logo?: Maybe<Image>;
  name: Scalars['String']['output'];
  noPhotoModeImage?: Maybe<Image>;
  orientation: LeaderboardOrientations;
  pointsSuffix: Scalars['String']['output'];
  promoPageTimer: Scalars['Int']['output'];
  promoPages: Array<PromoPages>;
  questions: Array<EventQuestion>;
  resultsPageTimer: Scalars['Int']['output'];
  showNewEntries: Scalars['Boolean']['output'];
  showUserPhotos: Scalars['Boolean']['output'];
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userEntries: UserWithEntriesConnection;
  winnerPageTimer: Scalars['Int']['output'];
};


export type LeaderboardBackgroundColorArgs = {
  format?: InputMaybe<ColorFormats>;
};


export type LeaderboardBackgroundTextColorArgs = {
  format?: InputMaybe<ColorFormats>;
};


export type LeaderboardForegroundColorArgs = {
  format?: InputMaybe<ColorFormats>;
};


export type LeaderboardForegroundTextColorArgs = {
  format?: InputMaybe<ColorFormats>;
};


export type LeaderboardHighlightColorArgs = {
  format?: InputMaybe<ColorFormats>;
};


export type LeaderboardUserEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Leaderboard. */
export type LeaderboardConnection = {
  __typename?: 'LeaderboardConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LeaderboardEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Leaderboard>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type LeaderboardEdge = {
  __typename?: 'LeaderboardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Leaderboard>;
};

/** Autogenerated return type of LeaderboardEntries. */
export type LeaderboardEntriesPayload = {
  __typename?: 'LeaderboardEntriesPayload';
  userEntries: Array<UserWithEntries>;
};

/** Leaderboard Fonts */
export enum LeaderboardFonts {
  /** Breakers leaderboard font */
  CircularStd = 'CIRCULAR_STD',
  /** Default leaderboard font */
  Default = 'DEFAULT',
  /** Figtree leaderboard font */
  Figtree = 'FIGTREE',
  /** New KFC leaderboard font */
  KnockoutFull = 'KNOCKOUT_FULL',
  /** KFC leaderboard font */
  KnockoutJunior = 'KNOCKOUT_JUNIOR',
  /** Myriad Pro leaderboard font */
  MyriadPro = 'MYRIAD_PRO',
  /** Oppo leaderboard font */
  OppoSans = 'OPPO_SANS',
  /** FIFA leaderboard font */
  SpaceGrotesk = 'SPACE_GROTESK',
  /** McDonalds leaderboard font */
  Speedee = 'SPEEDEE'
}

/** Leaderboard Orientation */
export enum LeaderboardOrientations {
  /** Horizontal orientation */
  Horizontal = 'HORIZONTAL',
  /** Vertical orientation */
  Vertical = 'VERTICAL'
}

export type ListGameEntry = Entry & Node & {
  __typename?: 'ListGameEntry';
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  data: Array<OptionSetEntry>;
  id: Scalars['ID']['output'];
  question: ListGameQuestion;
  quiz: ListGameQuiz;
  score: Scalars['Int']['output'];
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type ListGameQuestion = Node & Question & {
  __typename?: 'ListGameQuestion';
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  data: Array<OptionSetQuestion>;
  description?: Maybe<Scalars['String']['output']>;
  game: ListGames;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
  version: Scalars['Int']['output'];
};

export type ListGameQuiz = Node & Quiz & {
  __typename?: 'ListGameQuiz';
  additionalSharing: Array<AdditionalShare>;
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  form: QuizForm;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  questions: QuestionConnection;
  stylesheet: QuizStylesheet;
  template: QuizTemplate;
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
};


export type ListGameQuizQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The type of list game to load for a question */
export enum ListGames {
  /** Pick your rugby team lineup */
  RugbyTeamPicker = 'RUGBY_TEAM_PICKER',
  /** Pick your soccer team lineup */
  SoccerTeamPicker = 'SOCCER_TEAM_PICKER',
  /** Pick your team lineup */
  TeamPicker = 'TEAM_PICKER'
}

/**
 * MatchPick GraphQL API Mutations
 *
 */
export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Set that a user has made an additional share for a Quiz
   *
   * This mutation requires a User token in the Authorization header.
   *
   */
  additionalShare?: Maybe<AdditionalSharePayload>;
  createBasicQuizEntry?: Maybe<CreateBasicQuizEntryPayload>;
  createDisappearingImageEntry?: Maybe<CreateDisappearingImageEntryPayload>;
  createInteractiveQuizEntry?: Maybe<CreateInteractiveQuizEntryPayload>;
  createListGameEntry?: Maybe<CreateListGameEntryPayload>;
  createPersonalityQuizEntry?: Maybe<CreatePersonalityQuizEntryPayload>;
  /**
   * Create a user entry for a Poster event
   *
   * This mutation requires a User token in the Authorization header.
   *
   */
  createPosterEntry?: Maybe<CreatePosterEntryPayload>;
  /**
   * Create an order for poster entries
   *
   * This mutation requires a User token in the Authorization header.
   *
   */
  createPosterOrder?: Maybe<CreatePosterOrderPayload>;
  /**
   * Create an entry for a Quiz
   *
   * This mutation requires a User token in the Authorization header.
   *
   */
  createScratchAndWinEntries?: Maybe<CreateScratchAndWinEntriesPayload>;
  /**
   * Create a user record for a client
   *
   * This mutation requires a Client token in the Authorization header.
   *
   */
  createUser?: Maybe<CreateUserPayload>;
  judgeDualIntegersDualAnswerQuestion?: Maybe<DualIntegersDualAnswerMutationPayload>;
  judgeDualOptionSetsSingleAnswerQuestion?: Maybe<DualOptionSetsSingleAnswerMutationPayload>;
  judgeSingleOptionSetSingleAnswerQuestion?: Maybe<SingleOptionSetSingleAnswerMutationPayload>;
  /**
   * Set that a user has shared a Quiz
   *
   * This mutation requires a User token in the Authorization header.
   *
   */
  share?: Maybe<SharePayload>;
  /**
   * Add poster data to an existing poster entry.
   *
   * This mutation requires a User token in the Authorization header.
   *
   */
  updatePosterEntry?: Maybe<UpdatePosterEntryPayload>;
  /**
   * Updates the Graph users details
   *
   * This mutation requires a User token in the Authorization header.
   *
   */
  updateUser?: Maybe<UpdateUserPayload>;
};


/**
 * MatchPick GraphQL API Mutations
 *
 */
export type MutationAdditionalShareArgs = {
  input: AdditionalShareInput;
};


/**
 * MatchPick GraphQL API Mutations
 *
 */
export type MutationCreateBasicQuizEntryArgs = {
  input: CreateBasicQuizEntryInput;
};


/**
 * MatchPick GraphQL API Mutations
 *
 */
export type MutationCreateDisappearingImageEntryArgs = {
  input: CreateDisappearingImageEntryInput;
};


/**
 * MatchPick GraphQL API Mutations
 *
 */
export type MutationCreateInteractiveQuizEntryArgs = {
  input: CreateInteractiveQuizEntryInput;
};


/**
 * MatchPick GraphQL API Mutations
 *
 */
export type MutationCreateListGameEntryArgs = {
  input: CreateListGameEntryInput;
};


/**
 * MatchPick GraphQL API Mutations
 *
 */
export type MutationCreatePersonalityQuizEntryArgs = {
  input: CreatePersonalityQuizEntryInput;
};


/**
 * MatchPick GraphQL API Mutations
 *
 */
export type MutationCreatePosterEntryArgs = {
  input: CreatePosterEntryInput;
};


/**
 * MatchPick GraphQL API Mutations
 *
 */
export type MutationCreatePosterOrderArgs = {
  input: CreatePosterOrderInput;
};


/**
 * MatchPick GraphQL API Mutations
 *
 */
export type MutationCreateScratchAndWinEntriesArgs = {
  input: CreateScratchAndWinEntriesInput;
};


/**
 * MatchPick GraphQL API Mutations
 *
 */
export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


/**
 * MatchPick GraphQL API Mutations
 *
 */
export type MutationJudgeDualIntegersDualAnswerQuestionArgs = {
  input: DualIntegersDualAnswerMutationInput;
};


/**
 * MatchPick GraphQL API Mutations
 *
 */
export type MutationJudgeDualOptionSetsSingleAnswerQuestionArgs = {
  input: DualOptionSetsSingleAnswerMutationInput;
};


/**
 * MatchPick GraphQL API Mutations
 *
 */
export type MutationJudgeSingleOptionSetSingleAnswerQuestionArgs = {
  input: SingleOptionSetSingleAnswerMutationInput;
};


/**
 * MatchPick GraphQL API Mutations
 *
 */
export type MutationShareArgs = {
  input: ShareInput;
};


/**
 * MatchPick GraphQL API Mutations
 *
 */
export type MutationUpdatePosterEntryArgs = {
  input: UpdatePosterEntryInput;
};


/**
 * MatchPick GraphQL API Mutations
 *
 */
export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

export type MutationError = {
  __typename?: 'MutationError';
  attribute: Scalars['String']['output'];
  messages: Array<Scalars['String']['output']>;
};

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  id: Scalars['ID']['output'];
};

export type Option = Node & {
  __typename?: 'Option';
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type OptionSet = Node & {
  __typename?: 'OptionSet';
  id: Scalars['ID']['output'];
  options: Array<Option>;
  title: Scalars['String']['output'];
};

export type OptionSetAnswer = {
  __typename?: 'OptionSetAnswer';
  optionId?: Maybe<Scalars['ID']['output']>;
  optionSetId?: Maybe<Scalars['ID']['output']>;
};

export type OptionSetAnswerAttributes = {
  optionId: Scalars['ID']['input'];
  optionSetId: Scalars['ID']['input'];
};

export type OptionSetEntry = {
  __typename?: 'OptionSetEntry';
  option: Option;
  /** @deprecated Probably should use the option field directly */
  optionId: Scalars['ID']['output'];
  optionSet: OptionSet;
  /** @deprecated Probably should use the optionSet field directly */
  optionSetId: Scalars['ID']['output'];
};

export type OptionSetEntryInput = {
  optionId: Scalars['ID']['input'];
  optionSetId: Scalars['ID']['input'];
};

export type OptionSetExact = {
  __typename?: 'OptionSetExact';
  value: Scalars['Int']['output'];
};

export type OptionSetQuestion = {
  __typename?: 'OptionSetQuestion';
  description?: Maybe<Scalars['String']['output']>;
  optionSet: OptionSet;
};

export type OrderEntryInput = {
  copies: Scalars['Int']['input'];
  entryId: Scalars['ID']['input'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** An intent to pay by credit card for an order to be completed by the front end */
export type PaymentIntent = {
  __typename?: 'PaymentIntent';
  amount: Scalars['Int']['output'];
  clientSecret: Scalars['String']['output'];
  currency: Currency;
};

export type PersonalityQuiz = Node & Quiz & {
  __typename?: 'PersonalityQuiz';
  additionalSharing: Array<AdditionalShare>;
  categories: CategoryConnection;
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  form: QuizForm;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  questions: QuestionConnection;
  stylesheet: QuizStylesheet;
  template: QuizTemplate;
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
};


export type PersonalityQuizCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonalityQuizQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonalityQuizEntry = Entry & Node & {
  __typename?: 'PersonalityQuizEntry';
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  data: Array<CategoryEntry>;
  id: Scalars['ID']['output'];
  question: PersonalityQuizQuestion;
  quiz: PersonalityQuiz;
  score: Scalars['Int']['output'];
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
  values: Array<CategoryValue>;
};

export type PersonalityQuizQuestion = Node & Question & {
  __typename?: 'PersonalityQuizQuestion';
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  data: Array<CategoryQuestion>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
  version: Scalars['Int']['output'];
};

export type Poster = Node & Timestamps & {
  __typename?: 'Poster';
  additionalFields: Array<PosterField>;
  additionalPosterPrice: Scalars['Int']['output'];
  additionalSharing: Array<AdditionalShare>;
  backdrops: PosterBackdropConnection;
  backgroundRemoval: PosterBackgroundRemoval;
  /** @deprecated Deprecated in favour of PosterOutlet enum on outlet field */
  commercial: Scalars['Boolean']['output'];
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  domain: Scalars['String']['output'];
  form: PosterForm;
  id: Scalars['ID']['output'];
  initialPosterPrice: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  outlet: PosterOutlet;
  path: Scalars['String']['output'];
  shippingPrice: Scalars['Int']['output'];
  showAgeField: Scalars['Boolean']['output'];
  stylesheet: PosterStylesheet;
  template: PosterTemplate;
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
};


export type PosterBackdropsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PosterBackdrop = Node & Timestamps & {
  __typename?: 'PosterBackdrop';
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<ImageWithVersions>;
  settings: BackdropSettings;
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The connection type for PosterBackdrop. */
export type PosterBackdropConnection = {
  __typename?: 'PosterBackdropConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PosterBackdropEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PosterBackdrop>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PosterBackdropEdge = {
  __typename?: 'PosterBackdropEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PosterBackdrop>;
};

/** Poster background removal service */
export enum PosterBackgroundRemoval {
  /** No background removal */
  None = 'NONE',
  /** Python server */
  Python = 'PYTHON',
  /** remove.bg service */
  RemoveBg = 'REMOVE_BG'
}

/** The connection type for Poster. */
export type PosterConnection = {
  __typename?: 'PosterConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PosterEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Poster>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PosterDataInput = {
  additionalData?: InputMaybe<Array<AdditionalPosterDataInput>>;
  age?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  imageOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  layers?: InputMaybe<Array<PosterLayerInput>>;
};

/** An edge in a connection. */
export type PosterEdge = {
  __typename?: 'PosterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Poster>;
};

export type PosterEntry = Entry & Node & {
  __typename?: 'PosterEntry';
  backdrop: PosterBackdrop;
  compositeImage?: Maybe<Image>;
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  poster: Poster;
  posterData: PosterEntryData;
  score: Scalars['Int']['output'];
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type PosterEntryData = {
  __typename?: 'PosterEntryData';
  additionalData?: Maybe<Array<OptionSetEntry>>;
  age?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type PosterField = {
  __typename?: 'PosterField';
  optionSetId: Scalars['ID']['output'];
  options: Array<Option>;
  preselectedOptionId?: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
};

export type PosterForm = {
  __typename?: 'PosterForm';
  emailEnabled: Scalars['Boolean']['output'];
  emailLabel?: Maybe<Scalars['String']['output']>;
  emailPlaceholder?: Maybe<Scalars['String']['output']>;
  firstNameEnabled: Scalars['Boolean']['output'];
  firstNameLabel?: Maybe<Scalars['String']['output']>;
  firstNamePlaceholder?: Maybe<Scalars['String']['output']>;
  lastNameEnabled: Scalars['Boolean']['output'];
  lastNameLabel?: Maybe<Scalars['String']['output']>;
  lastNamePlaceholder?: Maybe<Scalars['String']['output']>;
  mobileNumberEnabled: Scalars['Boolean']['output'];
  mobileNumberLabel?: Maybe<Scalars['String']['output']>;
  mobileNumberPlaceholder?: Maybe<Scalars['String']['output']>;
  optInEnabled: Scalars['Boolean']['output'];
  optInLabel?: Maybe<Scalars['String']['output']>;
  termsAndConditionsEnabled: Scalars['Boolean']['output'];
  termsAndConditionsLabel?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type PosterLayerInput = {
  /** The role of the layer in the stack */
  name: Scalars['String']['input'];
  /** URL of the layer image */
  url: Scalars['String']['input'];
  /** Index in the stack starting from 1 (0 is the backdrop image) */
  zIndex: Scalars['Int']['input'];
};

/** An order for posters to be printed and delivered */
export type PosterOrder = Node & Timestamps & {
  __typename?: 'PosterOrder';
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  items: Array<PosterOrderItem>;
  shippingAmount: Scalars['Int']['output'];
  totalAmount: Scalars['Int']['output'];
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** A poster order item with copies to print and subtotal for those copies */
export type PosterOrderItem = Node & Timestamps & {
  __typename?: 'PosterOrderItem';
  copies: Scalars['Int']['output'];
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  subtotalAmount: Scalars['Int']['output'];
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Where for a Poster is destined */
export enum PosterOutlet {
  /** Commercial activations */
  Commercial = 'COMMERCIAL',
  /** Social matches */
  Social = 'SOCIAL',
  /** Ecommerce storefront */
  Storefront = 'STOREFRONT'
}

export type PosterStylesheet = {
  __typename?: 'PosterStylesheet';
  backgroundImage?: Maybe<ImageWithVersions>;
  bodyBgColor?: Maybe<Scalars['String']['output']>;
  bodyColor?: Maybe<Scalars['String']['output']>;
  cardBgColor?: Maybe<Scalars['String']['output']>;
  cardColor?: Maybe<Scalars['String']['output']>;
  dangerColor?: Maybe<Scalars['String']['output']>;
  darkColor?: Maybe<Scalars['String']['output']>;
  facebookShareImage?: Maybe<Image>;
  /** @deprecated Use headerImages field */
  headerImage?: Maybe<Image>;
  headerImages: Array<HeaderImage>;
  infoColor?: Maybe<Scalars['String']['output']>;
  lightColor?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  splashPageImage?: Maybe<ImageWithVersions>;
  successColor?: Maybe<Scalars['String']['output']>;
};

export type PosterTemplate = {
  __typename?: 'PosterTemplate';
  /** @deprecated The background image has been moved to the stylesheet object */
  backgroundImage?: Maybe<Image>;
  facebookShareButtonText?: Maybe<Scalars['String']['output']>;
  facebookShareDescription?: Maybe<Scalars['String']['output']>;
  facebookShareEnabled: Scalars['Boolean']['output'];
  /** @deprecated Facebook share image has been moved to the stylesheet object */
  facebookShareImage?: Maybe<Image>;
  facebookShareTitle?: Maybe<Scalars['String']['output']>;
  fbPixelId?: Maybe<Scalars['String']['output']>;
  finaliseText: Scalars['String']['output'];
  finaliseTitle: Scalars['String']['output'];
  formSuccessMessage: Scalars['String']['output'];
  formText: Scalars['String']['output'];
  formTitle: Scalars['String']['output'];
  gaId?: Maybe<Scalars['String']['output']>;
  /**
   * @deprecated       The header image has been moved to the stylesheet object.
   *
   *       Multiple header images are also now supported, use the headerImages collection on stylesheet instead.
   *
   */
  headerImage?: Maybe<Image>;
  howToPlayEnabled: Scalars['Boolean']['output'];
  howToPlayPages?: Maybe<Array<HowToPlayPage>>;
  pageDescription?: Maybe<Scalars['String']['output']>;
  pageTitle?: Maybe<Scalars['String']['output']>;
  personaliseCompletePhotoHeader: Scalars['String']['output'];
  personaliseText: Scalars['String']['output'];
  personaliseTitle: Scalars['String']['output'];
  resultsPageShareEnabled?: Maybe<Scalars['Boolean']['output']>;
  resultsPageShareText?: Maybe<Scalars['String']['output']>;
  resultsPageShareTitle?: Maybe<Scalars['String']['output']>;
  resultsPageText?: Maybe<Scalars['String']['output']>;
  splashPageEnabled: Scalars['Boolean']['output'];
  /** @deprecated The splash page image has been moved to the stylesheet object */
  splashPageImage?: Maybe<Image>;
  splashPageText?: Maybe<Scalars['String']['output']>;
  splashPageTitle?: Maybe<Scalars['String']['output']>;
  termsText: Scalars['String']['output'];
};

export type ProgressMessage = {
  __typename?: 'ProgressMessage';
  percent?: Maybe<Scalars['Int']['output']>;
  state: ProgressState;
  timestamp: Scalars['Float']['output'];
};

/** Progress of an action, e.g. judging a Question */
export enum ProgressState {
  /** Work complete */
  Complete = 'COMPLETE',
  /** Nothing happening */
  Idle = 'IDLE',
  /** Work being done */
  Working = 'WORKING'
}

export type PromoPages = Timestamps & {
  __typename?: 'PromoPages';
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  expires?: Maybe<Scalars['ISO8601DateTime']['output']>;
  image: Image;
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/**
 * MatchPick GraphQL API Queries
 *
 */
export type Query = {
  __typename?: 'Query';
  /** Fetches entries for the viewer */
  entries: EntryConnection;
  /** Fetches a list of event Leaderboards */
  leaderboards: LeaderboardConnection;
  /** Fetches an object given its ID */
  node?: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  /** Fetches a list of Poster events */
  posters: PosterConnection;
  /** Fetches a list of Quiz items */
  quizzes: QuizConnection;
  /** Fetches the viewer of the Graph */
  viewer: ViewerUnion;
};


/**
 * MatchPick GraphQL API Queries
 *
 */
export type QueryEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  quiz?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * MatchPick GraphQL API Queries
 *
 */
export type QueryLeaderboardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * MatchPick GraphQL API Queries
 *
 */
export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


/**
 * MatchPick GraphQL API Queries
 *
 */
export type QueryNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/**
 * MatchPick GraphQL API Queries
 *
 */
export type QueryPostersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
};


/**
 * MatchPick GraphQL API Queries
 *
 */
export type QueryQuizzesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** An object with an ID. */
export type Question = {
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
  version: Scalars['Int']['output'];
};

/** EventQuestionAnswer data types */
export type QuestionAnswerData = IntegerAnswer | OptionSetAnswer;

/** The connection type for Question. */
export type QuestionConnection = {
  __typename?: 'QuestionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<QuestionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Question>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type QuestionEdge = {
  __typename?: 'QuestionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Question>;
};

/** Autogenerated return type of QuestionJudgingProgress. */
export type QuestionJudgingProgressPayload = {
  __typename?: 'QuestionJudgingProgressPayload';
  progress: ProgressMessage;
  question?: Maybe<EventQuestion>;
};

/** Event question types */
export enum QuestionTypes {
  DataOnly = 'DATA_ONLY',
  DualIntegersDualAnswer = 'DUAL_INTEGERS_DUAL_ANSWER',
  DualOptionSetsSingleAnswer = 'DUAL_OPTION_SETS_SINGLE_ANSWER',
  SingleDurationSorted = 'SINGLE_DURATION_SORTED',
  SingleIntegerSorted = 'SINGLE_INTEGER_SORTED',
  SingleOptionSetSingleAnswer = 'SINGLE_OPTION_SET_SINGLE_ANSWER'
}

/** An object with an ID. */
export type Quiz = {
  additionalSharing: Array<AdditionalShare>;
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  form: QuizForm;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  questions: QuestionConnection;
  stylesheet: QuizStylesheet;
  template: QuizTemplate;
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
};


/** An object with an ID. */
export type QuizQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Quiz. */
export type QuizConnection = {
  __typename?: 'QuizConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<QuizEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Quiz>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type QuizEdge = {
  __typename?: 'QuizEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Quiz>;
};

export type QuizForm = {
  __typename?: 'QuizForm';
  emailEnabled: Scalars['Boolean']['output'];
  emailLabel?: Maybe<Scalars['String']['output']>;
  emailPlaceholder?: Maybe<Scalars['String']['output']>;
  firstNameEnabled: Scalars['Boolean']['output'];
  firstNameLabel?: Maybe<Scalars['String']['output']>;
  firstNamePlaceholder?: Maybe<Scalars['String']['output']>;
  lastNameEnabled: Scalars['Boolean']['output'];
  lastNameLabel?: Maybe<Scalars['String']['output']>;
  lastNamePlaceholder?: Maybe<Scalars['String']['output']>;
  mobileNumberEnabled: Scalars['Boolean']['output'];
  mobileNumberLabel?: Maybe<Scalars['String']['output']>;
  mobileNumberPlaceholder?: Maybe<Scalars['String']['output']>;
  optInEnabled: Scalars['Boolean']['output'];
  optInLabel?: Maybe<Scalars['String']['output']>;
  termsAndConditionsEnabled: Scalars['Boolean']['output'];
  termsAndConditionsLabel?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type QuizStylesheet = {
  __typename?: 'QuizStylesheet';
  backgroundImage?: Maybe<ImageWithVersions>;
  bodyBgColor?: Maybe<Scalars['String']['output']>;
  bodyColor?: Maybe<Scalars['String']['output']>;
  cardBgColor?: Maybe<Scalars['String']['output']>;
  cardColor?: Maybe<Scalars['String']['output']>;
  dangerColor?: Maybe<Scalars['String']['output']>;
  darkColor?: Maybe<Scalars['String']['output']>;
  facebookShareImage?: Maybe<Image>;
  /** @deprecated Use headerImages field */
  headerImage?: Maybe<Image>;
  headerImages: Array<HeaderImage>;
  infoColor?: Maybe<Scalars['String']['output']>;
  lightColor?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  splashPageImage?: Maybe<ImageWithVersions>;
  successColor?: Maybe<Scalars['String']['output']>;
};

export type QuizTemplate = {
  __typename?: 'QuizTemplate';
  /** @deprecated This field has moved to the QuizStylesheet type */
  backgroundImage?: Maybe<Image>;
  customCss?: Maybe<Scalars['String']['output']>;
  customJavascript?: Maybe<Scalars['String']['output']>;
  facebookShareButtonText?: Maybe<Scalars['String']['output']>;
  facebookShareDescription?: Maybe<Scalars['String']['output']>;
  facebookShareEnabled: Scalars['Boolean']['output'];
  /** @deprecated This field has moved to the QuizStylesheet type */
  facebookShareImage?: Maybe<Image>;
  facebookShareTitle?: Maybe<Scalars['String']['output']>;
  fbPixelId?: Maybe<Scalars['String']['output']>;
  gaId?: Maybe<Scalars['String']['output']>;
  /** @deprecated This field has moved to the QuizStylesheet type, and is now headerImages */
  headerImage?: Maybe<Image>;
  howToPlayEnabled: Scalars['Boolean']['output'];
  howToPlayPages?: Maybe<Array<HowToPlayPage>>;
  pageDescription?: Maybe<Scalars['String']['output']>;
  pageTitle?: Maybe<Scalars['String']['output']>;
  resultsPageShareEnabled?: Maybe<Scalars['Boolean']['output']>;
  resultsPageShareText?: Maybe<Scalars['String']['output']>;
  resultsPageShareTitle?: Maybe<Scalars['String']['output']>;
  resultsPageText?: Maybe<Scalars['String']['output']>;
  resultsPageTitle?: Maybe<Scalars['String']['output']>;
  splashPageEnabled: Scalars['Boolean']['output'];
  /** @deprecated This field has moved to the QuizStylesheet type */
  splashPageImage?: Maybe<Image>;
  splashPageText?: Maybe<Scalars['String']['output']>;
  splashPageTitle?: Maybe<Scalars['String']['output']>;
  termsText: Scalars['String']['output'];
};

export type ScratchAndWinEntry = Entry & Node & {
  __typename?: 'ScratchAndWinEntry';
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  question: ScratchAndWinQuestion;
  quiz: ScratchAndWinQuiz;
  score: Scalars['Int']['output'];
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
  winner: Scalars['Boolean']['output'];
};

export type ScratchAndWinQuestion = Node & Question & {
  __typename?: 'ScratchAndWinQuestion';
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  loseImage?: Maybe<ImageWithVersions>;
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  scratchImage?: Maybe<ImageWithVersions>;
  title: Scalars['String']['output'];
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
  version: Scalars['Int']['output'];
  winImage?: Maybe<ImageWithVersions>;
};

export type ScratchAndWinQuiz = Node & Quiz & {
  __typename?: 'ScratchAndWinQuiz';
  additionalSharing: Array<AdditionalShare>;
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  form: QuizForm;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  questions: QuestionConnection;
  stylesheet: QuizStylesheet;
  template: QuizTemplate;
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
};


export type ScratchAndWinQuizQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of Share */
export type ShareInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  via: Scalars['ID']['input'];
};

/** Autogenerated return type of Share. */
export type SharePayload = {
  __typename?: 'SharePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SingleOptionSetSingleAnswerMutation */
export type SingleOptionSetSingleAnswerMutationInput = {
  answer: OptionSetAnswerAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  questionId: Scalars['ID']['input'];
};

/** Autogenerated return type of SingleOptionSetSingleAnswerMutation. */
export type SingleOptionSetSingleAnswerMutationPayload = {
  __typename?: 'SingleOptionSetSingleAnswerMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  question: EventQuestion;
  success: Scalars['Boolean']['output'];
};

export type Sorted = {
  __typename?: 'Sorted';
  order: SortedOrder;
};

/** Sorting orders */
export enum SortedOrder {
  /** Smallest value first */
  Ascending = 'ASCENDING',
  /** Largest value first */
  Descending = 'DESCENDING'
}

export type Subscription = {
  __typename?: 'Subscription';
  leaderboardEntries: LeaderboardEntriesPayload;
  questionJudgingProgress: QuestionJudgingProgressPayload;
  userRankingProgress: UserRankingProgressPayload;
};


export type SubscriptionLeaderboardEntriesArgs = {
  leaderboardId: Scalars['ID']['input'];
};


export type SubscriptionQuestionJudgingProgressArgs = {
  questionId: Scalars['ID']['input'];
};


export type SubscriptionUserRankingProgressArgs = {
  eventId: Scalars['ID']['input'];
};

export type Timestamps = {
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of UpdatePosterEntry */
export type UpdatePosterEntryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  posterData: PosterDataInput;
  posterEntryId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdatePosterEntry. */
export type UpdatePosterEntryPayload = {
  __typename?: 'UpdatePosterEntryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<PosterEntry>;
  errors: Array<MutationError>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateUser */
export type UpdateUserInput = {
  /**
   * Terms and Conditions should be presented to and accepted by the current user.
   *
   * If for some reason this isn't required pass false here.
   *
   */
  acceptTerms: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Allows you to pass any additional form fields you need to record as JSON here.
   *
   */
  formData?: InputMaybe<Scalars['JSON']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  optIn?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the event the user is using, i.e. Event ID, Poster ID, Quiz ID */
  via: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateUser. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

export type User = Node & Timestamps & {
  __typename?: 'User';
  acceptTerms: Scalars['Boolean']['output'];
  additionalFields: Array<Scalars['JSON']['output']>;
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  email: Scalars['String']['output'];
  entered: Scalars['Boolean']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  mobileNumber: Scalars['String']['output'];
  optIn: Scalars['Boolean']['output'];
  shared: Scalars['Boolean']['output'];
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
};


export type UserEnteredArgs = {
  id: Scalars['ID']['input'];
};


export type UserSharedArgs = {
  id: Scalars['ID']['input'];
};

export type UserRanking = {
  __typename?: 'UserRanking';
  entries: Array<EventEntry>;
  equalWith: Scalars['Int']['output'];
  metadata: Scalars['JSON']['output'];
  rank: Scalars['Int']['output'];
  score: Scalars['Score']['output'];
  user: User;
};

/** Autogenerated return type of UserRankingProgress. */
export type UserRankingProgressPayload = {
  __typename?: 'UserRankingProgressPayload';
  progress: ProgressMessage;
  userRankings?: Maybe<Array<UserRanking>>;
};

export type UserWithEntries = Timestamps & {
  __typename?: 'UserWithEntries';
  avatar?: Maybe<ImageWithVersions>;
  created?: Maybe<Scalars['ISO8601DateTime']['output']>;
  entries: Array<EventEntry>;
  equalWith?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rank?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Score']['output']>;
  updated?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The connection type for UserWithEntries. */
export type UserWithEntriesConnection = {
  __typename?: 'UserWithEntriesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserWithEntriesEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<UserWithEntries>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserWithEntriesEdge = {
  __typename?: 'UserWithEntriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserWithEntries>;
};

/** Viewer types */
export type ViewerUnion = Client | User;

export type CreateUserMutationMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutationMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'CreateUserPayload', success: boolean, userToken?: { __typename?: 'AccessToken', token: string, expiresIn: number } | null } | null };

export type GetPostersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPostersQuery = { __typename?: 'Query', posters: { __typename?: 'PosterConnection', nodes?: Array<{ __typename?: 'Poster', id: string, path: string, backgroundRemoval: PosterBackgroundRemoval, template: { __typename?: 'PosterTemplate', facebookShareTitle?: string | null, facebookShareDescription?: string | null, splashPageText?: string | null, splashPageEnabled: boolean, pageTitle?: string | null, gaId?: string | null }, backdrops: { __typename?: 'PosterBackdropConnection', nodes?: Array<{ __typename?: 'PosterBackdrop', id: string, image?: { __typename?: 'ImageWithVersions', url: string, versions: { __typename?: 'ImageVersions', large?: { __typename?: 'Image', url: string } | null } } | null } | null> | null }, stylesheet: { __typename?: 'PosterStylesheet', bodyBgColor?: string | null, bodyColor?: string | null, cardBgColor?: string | null, cardColor?: string | null, dangerColor?: string | null, infoColor?: string | null, lightColor?: string | null, primaryColor?: string | null, secondaryColor?: string | null, successColor?: string | null, headerImages: Array<{ __typename?: 'HeaderImage', url: string, role: HeaderImageRole }>, splashPageImage?: { __typename?: 'ImageWithVersions', versions: { __typename?: 'ImageVersions', large?: { __typename?: 'Image', url: string } | null } } | null } } | null> | null } };

export type UpdateUserMutationMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutationMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'UpdateUserPayload', success: boolean, errors?: Array<{ __typename?: 'MutationError', attribute: string, messages: Array<string> }> | null, user?: { __typename?: 'User', id: string } | null } | null };

export type GetPosterQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPosterQuery = { __typename?: 'Query', node?: { __typename?: 'AdditionalShare', id: string } | { __typename?: 'BasicQuiz', id: string } | { __typename?: 'BasicQuizEntry', id: string } | { __typename?: 'BasicQuizQuestion', id: string } | { __typename?: 'Client', id: string } | { __typename?: 'DisappearingImageEntry', id: string } | { __typename?: 'DisappearingImageQuestion', id: string } | { __typename?: 'DisappearingImageQuiz', id: string } | { __typename?: 'Event', id: string } | { __typename?: 'EventEntry', id: string } | { __typename?: 'EventQuestion', id: string } | { __typename?: 'InteractiveQuiz', id: string } | { __typename?: 'InteractiveQuizEntry', id: string } | { __typename?: 'InteractiveQuizQuestion', id: string } | { __typename?: 'Leaderboard', id: string } | { __typename?: 'ListGameEntry', id: string } | { __typename?: 'ListGameQuestion', id: string } | { __typename?: 'ListGameQuiz', id: string } | { __typename?: 'Option', id: string } | { __typename?: 'OptionSet', id: string } | { __typename?: 'PersonalityQuiz', id: string } | { __typename?: 'PersonalityQuizEntry', id: string } | { __typename?: 'PersonalityQuizQuestion', id: string } | { __typename?: 'Poster', name: string, domain: string, path: string, commercial: boolean, backgroundRemoval: PosterBackgroundRemoval, initialPosterPrice: number, id: string, additionalFields: Array<{ __typename?: 'PosterField', title: string, options: Array<{ __typename?: 'Option', title: string }> }>, backdrops: { __typename?: 'PosterBackdropConnection', nodes?: Array<{ __typename?: 'PosterBackdrop', id: string, image?: { __typename?: 'ImageWithVersions', url: string, versions: { __typename?: 'ImageVersions', large?: { __typename?: 'Image', url: string } | null } } | null } | null> | null }, form: { __typename?: 'PosterForm', emailLabel?: string | null, emailEnabled: boolean, emailPlaceholder?: string | null, firstNameLabel?: string | null, firstNameEnabled: boolean, firstNamePlaceholder?: string | null, lastNameLabel?: string | null, lastNameEnabled: boolean, lastNamePlaceholder?: string | null, mobileNumberLabel?: string | null, mobileNumberEnabled: boolean, mobileNumberPlaceholder?: string | null, optInLabel?: string | null, optInEnabled: boolean, termsAndConditionsLabel?: string | null, termsAndConditionsEnabled: boolean, title: string }, stylesheet: { __typename?: 'PosterStylesheet', bodyBgColor?: string | null, bodyColor?: string | null, cardBgColor?: string | null, cardColor?: string | null, dangerColor?: string | null, infoColor?: string | null, lightColor?: string | null, primaryColor?: string | null, secondaryColor?: string | null, successColor?: string | null, backgroundImage?: { __typename?: 'ImageWithVersions', versions: { __typename?: 'ImageVersions', large?: { __typename?: 'Image', url: string } | null } } | null, headerImages: Array<{ __typename?: 'HeaderImage', url: string, role: HeaderImageRole }>, splashPageImage?: { __typename?: 'ImageWithVersions', url: string } | null }, template: { __typename?: 'PosterTemplate', facebookShareTitle?: string | null, facebookShareDescription?: string | null, personaliseText: string, personaliseTitle: string, finaliseText: string, finaliseTitle: string, formText: string, formTitle: string, pageTitle?: string | null, pageDescription?: string | null, splashPageText?: string | null, splashPageEnabled: boolean, howToPlayEnabled: boolean, termsText: string, howToPlayPages?: Array<{ __typename?: 'HowToPlayPage', id: string, position: number, text?: string | null, title: string, icon?: { __typename?: 'Image', url: string } | null }> | null } } | { __typename?: 'PosterBackdrop', id: string } | { __typename?: 'PosterEntry', id: string } | { __typename?: 'PosterOrder', id: string } | { __typename?: 'PosterOrderItem', id: string } | { __typename?: 'ScratchAndWinEntry', id: string } | { __typename?: 'ScratchAndWinQuestion', id: string } | { __typename?: 'ScratchAndWinQuiz', id: string } | { __typename?: 'User', id: string } | null };

export type CreatePosterEntryMutationMutationVariables = Exact<{
  input: CreatePosterEntryInput;
}>;


export type CreatePosterEntryMutationMutation = { __typename?: 'Mutation', createPosterEntry?: { __typename?: 'CreatePosterEntryPayload', success: boolean, errors: Array<{ __typename?: 'MutationError', attribute: string, messages: Array<string> }>, entry?: { __typename?: 'PosterEntry', id: string } | null } | null };

export type CreatePosterOrderMutationMutationVariables = Exact<{
  input: CreatePosterOrderInput;
}>;


export type CreatePosterOrderMutationMutation = { __typename?: 'Mutation', createPosterOrder?: { __typename?: 'CreatePosterOrderPayload', success: boolean, errors: Array<{ __typename?: 'MutationError', attribute: string, messages: Array<string> }>, intent?: { __typename?: 'PaymentIntent', amount: number, clientSecret: string, currency: Currency } | null } | null };


export const CreateUserMutationDocument = gql`
    mutation CreateUserMutation($input: CreateUserInput!) {
  createUser(input: $input) {
    success
    userToken {
      token
      expiresIn
    }
  }
}
    `;
export type CreateUserMutationMutationFn = Apollo.MutationFunction<CreateUserMutationMutation, CreateUserMutationMutationVariables>;

/**
 * __useCreateUserMutationMutation__
 *
 * To run a mutation, you first call `useCreateUserMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutationMutation, { data, loading, error }] = useCreateUserMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutationMutation, CreateUserMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutationMutation, CreateUserMutationMutationVariables>(CreateUserMutationDocument, options);
      }
export type CreateUserMutationMutationHookResult = ReturnType<typeof useCreateUserMutationMutation>;
export type CreateUserMutationMutationResult = Apollo.MutationResult<CreateUserMutationMutation>;
export type CreateUserMutationMutationOptions = Apollo.BaseMutationOptions<CreateUserMutationMutation, CreateUserMutationMutationVariables>;
export const GetPostersDocument = gql`
    query getPosters {
  posters {
    nodes {
      id
      path
      backgroundRemoval
      template {
        facebookShareTitle
        facebookShareDescription
        splashPageText
        splashPageEnabled
        pageTitle
        gaId
      }
      backdrops {
        nodes {
          id
          image {
            url
            versions {
              large {
                url
              }
            }
          }
        }
      }
      stylesheet {
        bodyBgColor
        bodyColor
        cardBgColor
        cardColor
        dangerColor
        headerImages {
          url
          role
        }
        infoColor
        lightColor
        primaryColor
        secondaryColor
        splashPageImage {
          versions {
            large {
              url
            }
          }
        }
        successColor
      }
    }
  }
}
    `;

/**
 * __useGetPostersQuery__
 *
 * To run a query within a React component, call `useGetPostersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPostersQuery(baseOptions?: Apollo.QueryHookOptions<GetPostersQuery, GetPostersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostersQuery, GetPostersQueryVariables>(GetPostersDocument, options);
      }
export function useGetPostersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostersQuery, GetPostersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostersQuery, GetPostersQueryVariables>(GetPostersDocument, options);
        }
export function useGetPostersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPostersQuery, GetPostersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPostersQuery, GetPostersQueryVariables>(GetPostersDocument, options);
        }
export type GetPostersQueryHookResult = ReturnType<typeof useGetPostersQuery>;
export type GetPostersLazyQueryHookResult = ReturnType<typeof useGetPostersLazyQuery>;
export type GetPostersSuspenseQueryHookResult = ReturnType<typeof useGetPostersSuspenseQuery>;
export type GetPostersQueryResult = Apollo.QueryResult<GetPostersQuery, GetPostersQueryVariables>;
export const UpdateUserMutationDocument = gql`
    mutation UpdateUserMutation($input: UpdateUserInput!) {
  updateUser(input: $input) {
    success
    errors {
      attribute
      messages
    }
    user {
      id
    }
  }
}
    `;
export type UpdateUserMutationMutationFn = Apollo.MutationFunction<UpdateUserMutationMutation, UpdateUserMutationMutationVariables>;

/**
 * __useUpdateUserMutationMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutationMutation, { data, loading, error }] = useUpdateUserMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutationMutation, UpdateUserMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutationMutation, UpdateUserMutationMutationVariables>(UpdateUserMutationDocument, options);
      }
export type UpdateUserMutationMutationHookResult = ReturnType<typeof useUpdateUserMutationMutation>;
export type UpdateUserMutationMutationResult = Apollo.MutationResult<UpdateUserMutationMutation>;
export type UpdateUserMutationMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutationMutation, UpdateUserMutationMutationVariables>;
export const GetPosterDocument = gql`
    query getPoster($id: ID!) {
  node(id: $id) {
    id
    ... on Poster {
      name
      domain
      path
      commercial
      backgroundRemoval
      initialPosterPrice
      additionalFields {
        title
        options {
          title
        }
      }
      backdrops {
        nodes {
          id
          image {
            url
            versions {
              large {
                url
              }
            }
          }
        }
      }
      form {
        emailLabel
        emailEnabled
        emailPlaceholder
        firstNameLabel
        firstNameEnabled
        firstNamePlaceholder
        lastNameLabel
        lastNameEnabled
        lastNamePlaceholder
        mobileNumberLabel
        mobileNumberEnabled
        mobileNumberPlaceholder
        optInLabel
        optInEnabled
        termsAndConditionsLabel
        termsAndConditionsEnabled
        title
      }
      stylesheet {
        backgroundImage {
          versions {
            large {
              url
            }
          }
        }
        bodyBgColor
        bodyColor
        cardBgColor
        cardColor
        dangerColor
        headerImages {
          url
          role
        }
        infoColor
        lightColor
        primaryColor
        secondaryColor
        splashPageImage {
          url
        }
        successColor
      }
      template {
        facebookShareTitle
        facebookShareDescription
        personaliseText
        personaliseTitle
        personaliseText
        personaliseTitle
        finaliseText
        finaliseTitle
        formText
        formTitle
        pageTitle
        pageDescription
        splashPageText
        splashPageEnabled
        howToPlayEnabled
        termsText
        howToPlayPages {
          id
          position
          text
          title
          icon {
            url
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPosterQuery__
 *
 * To run a query within a React component, call `useGetPosterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPosterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPosterQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPosterQuery(baseOptions: Apollo.QueryHookOptions<GetPosterQuery, GetPosterQueryVariables> & ({ variables: GetPosterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPosterQuery, GetPosterQueryVariables>(GetPosterDocument, options);
      }
export function useGetPosterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPosterQuery, GetPosterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPosterQuery, GetPosterQueryVariables>(GetPosterDocument, options);
        }
export function useGetPosterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPosterQuery, GetPosterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPosterQuery, GetPosterQueryVariables>(GetPosterDocument, options);
        }
export type GetPosterQueryHookResult = ReturnType<typeof useGetPosterQuery>;
export type GetPosterLazyQueryHookResult = ReturnType<typeof useGetPosterLazyQuery>;
export type GetPosterSuspenseQueryHookResult = ReturnType<typeof useGetPosterSuspenseQuery>;
export type GetPosterQueryResult = Apollo.QueryResult<GetPosterQuery, GetPosterQueryVariables>;
export const CreatePosterEntryMutationDocument = gql`
    mutation CreatePosterEntryMutation($input: CreatePosterEntryInput!) {
  createPosterEntry(input: $input) {
    success
    errors {
      attribute
      messages
    }
    entry {
      id
    }
  }
}
    `;
export type CreatePosterEntryMutationMutationFn = Apollo.MutationFunction<CreatePosterEntryMutationMutation, CreatePosterEntryMutationMutationVariables>;

/**
 * __useCreatePosterEntryMutationMutation__
 *
 * To run a mutation, you first call `useCreatePosterEntryMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePosterEntryMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPosterEntryMutationMutation, { data, loading, error }] = useCreatePosterEntryMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePosterEntryMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreatePosterEntryMutationMutation, CreatePosterEntryMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePosterEntryMutationMutation, CreatePosterEntryMutationMutationVariables>(CreatePosterEntryMutationDocument, options);
      }
export type CreatePosterEntryMutationMutationHookResult = ReturnType<typeof useCreatePosterEntryMutationMutation>;
export type CreatePosterEntryMutationMutationResult = Apollo.MutationResult<CreatePosterEntryMutationMutation>;
export type CreatePosterEntryMutationMutationOptions = Apollo.BaseMutationOptions<CreatePosterEntryMutationMutation, CreatePosterEntryMutationMutationVariables>;
export const CreatePosterOrderMutationDocument = gql`
    mutation CreatePosterOrderMutation($input: CreatePosterOrderInput!) {
  createPosterOrder(input: $input) {
    success
    errors {
      attribute
      messages
    }
    intent {
      amount
      clientSecret
      currency
    }
  }
}
    `;
export type CreatePosterOrderMutationMutationFn = Apollo.MutationFunction<CreatePosterOrderMutationMutation, CreatePosterOrderMutationMutationVariables>;

/**
 * __useCreatePosterOrderMutationMutation__
 *
 * To run a mutation, you first call `useCreatePosterOrderMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePosterOrderMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPosterOrderMutationMutation, { data, loading, error }] = useCreatePosterOrderMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePosterOrderMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreatePosterOrderMutationMutation, CreatePosterOrderMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePosterOrderMutationMutation, CreatePosterOrderMutationMutationVariables>(CreatePosterOrderMutationDocument, options);
      }
export type CreatePosterOrderMutationMutationHookResult = ReturnType<typeof useCreatePosterOrderMutationMutation>;
export type CreatePosterOrderMutationMutationResult = Apollo.MutationResult<CreatePosterOrderMutationMutation>;
export type CreatePosterOrderMutationMutationOptions = Apollo.BaseMutationOptions<CreatePosterOrderMutationMutation, CreatePosterOrderMutationMutationVariables>;